module.exports = __webpack_public_path__ + "static/media/rewind-fast.69d24570.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/rewind-fast.mp3
// module id = 41
// module chunks = 1